import { Dialog, DialogContent } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import PopupAppBar from '../../Common/PopupAppBar';
import DownloadMapDataList from './downloadMapDataList';
import useDownloadMapDataPopup, { DownloadMapDataPopupProps } from '../hooks/useDownloadMapDataPopup';


const DownloadMapDataPopup = (props: DownloadMapDataPopupProps): JSX.Element => {

    const popup = useDownloadMapDataPopup(props);

    return (
      <Dialog
          fullScreen
          open={props.action.isActive}
          onClose={props.action.cancel}
      >
        <PopupAppBar title="Map Data Download" icon={<DownloadIcon/>} onClose={props.action.cancel} showNetworkStatus={true} />

        <DialogContent>
        {popup.map && popup.urlTemplate && 
          <DownloadMapDataList minZoom={popup.minZoom} maxZoom={popup.maxZoom} tileCacheSeeder={props.tileCacheSeeder} snapshotGen={props.snapshotGen} urlTemplate={popup.urlTemplate} urlSubdomains={popup.urlSubdomains}/>
        }
        </DialogContent>

      </Dialog>
    );
};

export default DownloadMapDataPopup;